// BƯỚC "ĐĂNG VIDEO" (06/10/2026) — cấu hình + nội dung đăng + lời tóm tắt, phần THUẦN dùng chung bot / Boss / trang web / test.
//
// Cấu hình của bước nằm trong MỘT tham số của sơ đồ: `cau_hinh_video` = chữ gọn "khoá=giá trị;…" (xem CauHinhVideoGoc). Trang Kịch bản dựng ô riêng (nút bấm, mục "Nâng cao" thu gọn,
// dòng tóm tắt) — người dùng không phải hiểu cấu hình. Bản chạy được mang bản đã CHUẨN HOÁ ở khoá `dang_video` của bước (CauHinhDangVideo, đủ giá trị an toàn mặc định). Dạng ghi: "khoá=giá trị;…" (tham số sơ đồ không cho nháy kép / ngoặc nhọn)..
import { laCheDoChon, type CheDoChon } from "./video-chon";
import {
  chuanHashtag, chuanMoTa, chuanTieuDe, ghiHashtag, laNenTangVideo, moTaGiongHet, NHAN_KIEU_DANG, TEN_NEN_TANG_VIDEO,
  type KieuDangYeuCau, type KieuDangVideo, type NenTangVideo,
} from "./video-kho";

/** Tham số duy nhất của khối (xem ban-do.ts / video-khoi.ts). */
export const TEN_THAM_SO_VIDEO = "cau_hinh_video";
/** Plugin thấp nhất chạy được bước đăng video (src/shared/phien-ban-plugin.ts dùng). */
export const PLUGIN_CAN_DANG_VIDEO = "0.1.57";

export type CheDoDang = "thu" | "cong_khai";
export type CachVietNoiDung = "mau" | "ai";

/** Dạng người dùng / trang web ghi (tên khoá ngắn). */
export interface CauHinhVideoGoc {
  chon: CheDoChon;
  nhan: string;
  kieu: KieuDangYeuCau;
  che_do: CheDoDang;
  duyet: "co" | "khong";
  noi_dung: CachVietNoiDung;
  tran: number;
  cho_tu: number;
  cho_den: number;
  lech: number;
  khong_cung_ngay: boolean;
  moi_video_mot_bot: boolean;
  video_id: string;
  /** Tối đa phút chờ video xử lý xong sau khi tải lên. */
  cho_xu_ly: number;
}

/** Mặc định AN TOÀN (khớp cẩm nang): thử/riêng tư, ≤ 1 video/ngày, chờ 3–6 giờ giữa hai lần, lệch giờ ≤ 20 phút, không cùng video cùng ngày. */
export const MAC_DINH_VIDEO: Readonly<CauHinhVideoGoc> = Object.freeze({
  chon: "lan_luot", nhan: "", kieu: "tu_nhan", che_do: "thu", duyet: "khong", noi_dung: "mau",
  tran: 1, cho_tu: 180, cho_den: 360, lech: 20, khong_cung_ngay: true, moi_video_mot_bot: false, video_id: "", cho_xu_ly: 45,
} as CauHinhVideoGoc);

/** Trần mặc định theo nền tảng khi người dùng chưa đổi (khớp cẩm nang: FB ≤ 1, YouTube ≤ 1, TikTok ≤ 2 video/ngày). */
export const TRAN_NGAY_MAC_DINH: Readonly<Record<NenTangVideo, number>> = { facebook: 1, youtube: 1, tiktok: 2 };
export const TRAN_NGAY_TOI_DA = 10;
export const CHO_PHUT_TOI_DA = 24 * 60;
export const LECH_PHUT_TOI_DA = 120;
export const CHO_XU_LY_TOI_DA = 180;
export const NHAN_TOI_DA = 40;
export const GIOI_HAN_JSON = 480; // ô tham số sơ đồ ≤ 500 ký tự

export const NHAN_CHE_DO_DANG: Readonly<Record<CheDoDang, string>> = { thu: "Thử (riêng tư)", cong_khai: "Công khai" };
export const NHAN_CHE_DO_CHON: Readonly<Record<CheDoChon, string>> = { lan_luot: "Lần lượt", ngau_nhien: "Ngẫu nhiên", theo_nhan: "Theo nhãn" };

const soTrongKhoang = (v: unknown, min: number, max: number, macDinh: number): number => {
  const n = typeof v === "number" ? v : typeof v === "string" && v.trim() !== "" ? Number(v) : NaN;
  if (!Number.isFinite(n)) return macDinh;
  return Math.max(min, Math.min(max, Math.round(n)));
};
const dungSai = (v: unknown, macDinh: boolean): boolean => (v === true || v === "co" || v === "true" || v === 1 ? true : v === false || v === "khong" || v === "false" || v === 0 ? false : macDinh);

/** "chon=lan_luot;nhan=áo;tran=1" → đối tượng (giá trị là chữ). Không ném. Khoá lạ giữ nguyên (chuanCauHinhVideo bỏ qua). */
export function docChuoiCauHinh(v: string): Record<string, unknown> {
  const o: Record<string, unknown> = {};
  for (const phan of v.split(";")) {
    const i = phan.indexOf("=");
    if (i <= 0) continue;
    o[phan.slice(0, i).trim()] = phan.slice(i + 1).trim();
  }
  return o;
}

/** Chuẩn hoá cấu hình (từ chữ "khoá=giá trị;…" hoặc đối tượng; giá trị lạ → mặc định an toàn). Không ném. */
export function chuanCauHinhVideo(v: unknown, nenTang: NenTangVideo = "facebook"): CauHinhVideoGoc {
  const o: Record<string, unknown> = typeof v === "string" ? docChuoiCauHinh(v) : v && typeof v === "object" && !Array.isArray(v) ? { ...(v as Record<string, unknown>) } : {};
  const M = MAC_DINH_VIDEO;
  const chon = laCheDoChon(o.chon) ? o.chon : M.chon;
  const nhan = typeof o.nhan === "string" ? Array.from(o.nhan.replace(/[\u0000-\u001f\u007f"{},]+/g, " ").replace(/\s+/g, " ").trim()).slice(0, NHAN_TOI_DA).join("").trim() : "";
  const kieu: KieuDangYeuCau = o.kieu === "bai_thuong" || o.kieu === "reel" ? o.kieu : "tu_nhan";
  const choTu = soTrongKhoang(o.cho_tu, 0, CHO_PHUT_TOI_DA, M.cho_tu);
  const choDen = Math.max(choTu, soTrongKhoang(o.cho_den, 0, CHO_PHUT_TOI_DA, M.cho_den));
  const videoId = typeof o.video_id === "string" && /^kv-[a-z0-9]{14}$/.test(o.video_id) ? o.video_id : "";
  return {
    chon, nhan, kieu: nenTang === "facebook" || o.kieu !== "reel" ? kieu : "tu_nhan",
    che_do: o.che_do === "cong_khai" ? "cong_khai" : "thu",
    duyet: o.duyet === "co" ? "co" : "khong",
    noi_dung: o.noi_dung === "ai" ? "ai" : "mau",
    tran: soTrongKhoang(o.tran, 0, TRAN_NGAY_TOI_DA, TRAN_NGAY_MAC_DINH[nenTang]),
    cho_tu: choTu, cho_den: choDen,
    lech: soTrongKhoang(o.lech, 0, LECH_PHUT_TOI_DA, M.lech),
    khong_cung_ngay: dungSai(o.khong_cung_ngay, M.khong_cung_ngay),
    moi_video_mot_bot: dungSai(o.moi_video_mot_bot, M.moi_video_mot_bot),
    video_id: videoId,
    cho_xu_ly: soTrongKhoang(o.cho_xu_ly, 1, CHO_XU_LY_TOI_DA, M.cho_xu_ly),
  };
}

/** Giá trị MẶC ĐỊNH của tham số `cau_hinh_video` cho một nền tảng (chuỗi JSON gọn). */
export function macDinhThamSoVideo(nenTang: NenTangVideo): string {
  return ghiCauHinhVideo({ ...MAC_DINH_VIDEO, tran: TRAN_NGAY_MAC_DINH[nenTang] });
}

/** Ghi cấu hình thành chữ gọn "khoá=giá trị;…" (không nháy kép / ngoặc nhọn — tham số sơ đồ không cho), THỨ TỰ ổn định (cùng cấu hình → cùng chữ → cùng hash bundle). */
export function ghiCauHinhVideo(c: CauHinhVideoGoc): string {
  const b = (x: boolean) => (x ? "co" : "khong");
  return [`chon=${c.chon}`, `nhan=${c.nhan}`, `kieu=${c.kieu}`, `che_do=${c.che_do}`, `duyet=${c.duyet}`, `noi_dung=${c.noi_dung}`, `tran=${c.tran}`, `cho_tu=${c.cho_tu}`, `cho_den=${c.cho_den}`,
    `lech=${c.lech}`, `khong_cung_ngay=${b(c.khong_cung_ngay)}`, `moi_video_mot_bot=${b(c.moi_video_mot_bot)}`, `video_id=${c.video_id}`, `cho_xu_ly=${c.cho_xu_ly}`].join(";");
}

/** Lỗi (câu tiếng Việt) của giá trị tham số `cau_hinh_video`; null = hợp lệ. Rỗng = hợp lệ (dùng mặc định). */
export function loiCauHinhVideo(v: unknown, nenTang: NenTangVideo = "facebook"): string | null {
  if (v === undefined || v === null || v === "") return null;
  if (typeof v !== "string") return "phải là chữ";
  if (Array.from(v).length > GIOI_HAN_JSON) return `quá dài (tối đa ${GIOI_HAN_JSON} ký tự)`;
  if (/["{}\r\n]/.test(v)) return "có ký tự không hợp lệ (hãy chọn lại bằng các nút)";
  const r = docChuoiCauHinh(v);
  const so = (k: string, min: number, max: number, ten: string): string | null => {
    if (r[k] === undefined) return null;
    const s = String(r[k]);
    const n = Number(s);
    return s.trim() !== "" && Number.isInteger(n) && n >= min && n <= max ? null : `${ten} phải là số nguyên từ ${min} đến ${max}`;
  };
  const trong = (k: string, ds: readonly string[], ten: string): string | null => (r[k] === undefined || ds.includes(String(r[k])) ? null : `${ten} không hợp lệ`);
  const loi = [
    trong("chon", ["lan_luot", "ngau_nhien", "theo_nhan"], "cách chọn video"),
    trong("che_do", ["thu", "cong_khai"], "chế độ đăng"),
    trong("kieu", ["tu_nhan", "bai_thuong", "reel"], "kiểu đăng"),
    trong("noi_dung", ["mau", "ai"], "cách viết nội dung"),
    trong("duyet", ["co", "khong"], "ô cần duyệt"),
    trong("khong_cung_ngay", ["co", "khong"], "ô không cùng video cùng ngày"),
    trong("moi_video_mot_bot", ["co", "khong"], "ô mỗi video một bot"),
    so("tran", 0, TRAN_NGAY_TOI_DA, "trần mỗi ngày"), so("cho_tu", 0, CHO_PHUT_TOI_DA, "“Chờ từ”"), so("cho_den", 0, CHO_PHUT_TOI_DA, "“Chờ đến”"),
    so("lech", 0, LECH_PHUT_TOI_DA, "lệch giờ"), so("cho_xu_ly", 1, CHO_XU_LY_TOI_DA, "thời gian chờ xử lý"),
    r.video_id !== undefined && r.video_id !== "" && !/^kv-[a-z0-9]{14}$/.test(String(r.video_id)) ? "mã video không hợp lệ" : null,
  ].find((x) => x);
  if (loi) return loi;
  if (r.cho_tu !== undefined && r.cho_den !== undefined && Number(r.cho_den) < Number(r.cho_tu)) return "“Chờ đến” phải lớn hơn hoặc bằng “Chờ từ”";
  const c = chuanCauHinhVideo(v, nenTang);
  if (c.chon === "theo_nhan" && !c.nhan && !c.video_id) return "chọn “Theo nhãn” thì phải ghi nhãn";
  if (r.kieu === "reel" && nenTang !== "facebook") return "“Luôn Reel” chỉ dùng cho Facebook";
  return null;
}

const giuaChu = (n: number): string => (n === 1 ? "1" : String(n));
const chuPhut = (p: number): string => (p >= 60 && p % 60 === 0 ? `${p / 60} giờ` : p >= 60 ? `${Math.floor(p / 60)} giờ ${p % 60} phút` : `${p} phút`);

/**
 * Dòng TÓM TẮT bằng tiếng Việt thường (hiện ngay dưới các nút): "Mỗi lần chạy: lấy 1 video chưa đăng (cũ nhất), đăng riêng tư lên Facebook dạng Reel
 * (nếu video ngắn và dọc); tối đa 1 video/ngày."
 */
export function tomTatDangVideo(nenTang: NenTangVideo, v: unknown): string {
  const c = chuanCauHinhVideo(v, nenTang);
  const ten = TEN_NEN_TANG_VIDEO[nenTang];
  const lay = c.video_id ? "đăng đúng video đã chọn (1 lần)" : c.chon === "ngau_nhien" ? "lấy 1 video chưa đăng (ngẫu nhiên)" : c.chon === "theo_nhan" ? `lấy 1 video chưa đăng có nhãn “${c.nhan || "…"}” (cũ nhất)` : "lấy 1 video chưa đăng (cũ nhất)";
  const che = c.che_do === "thu" ? "đăng riêng tư (thử)" : "đăng công khai";
  const kieu = nenTang === "facebook" ? (c.kieu === "reel" ? " dạng Reel" : c.kieu === "bai_thuong" ? " dạng bài video trên Tường" : " (Reel nếu video ngắn và dọc, còn lại bài trên Tường)")
    : nenTang === "youtube" ? (c.kieu === "bai_thuong" ? " dạng video thường" : " (Shorts nếu video ≤ 60 giây và dọc)") : "";
  const tran = c.tran > 0 ? `tối đa ${giuaChu(c.tran)} video/ngày` : "không giới hạn số video mỗi ngày";
  const cho = c.cho_tu > 0 || c.cho_den > 0 ? `; cách nhau ${c.cho_tu === c.cho_den ? chuPhut(c.cho_tu) : `${chuPhut(c.cho_tu)}–${chuPhut(c.cho_den)}`}` : "";
  const duyet = c.duyet === "co" ? "; chờ bạn duyệt trước khi bấm Đăng" : "";
  const nd = c.noi_dung === "ai" ? "; AI viết lại mô tả cho mỗi bot" : "";
  return `Mỗi lần chạy: ${lay}, ${che} lên ${ten}${kieu}; ${tran}${cho}${duyet}${nd}.`;
}

/** Dạng bước đã CHUẨN HOÁ nằm trong bundle (khoá dang_video của BundleStep). */
export interface CauHinhDangVideo extends CauHinhVideoGoc { nen_tang: NenTangVideo }

/** Đọc khoá dang_video của bước trong bundle (từ chữ JSON hoặc đối tượng). nen_tang sai → null. */
export function docDangVideo(raw: unknown): CauHinhDangVideo | null {
  if (!raw || typeof raw !== "object" || Array.isArray(raw)) return null;
  const o = raw as Record<string, unknown>;
  if (!laNenTangVideo(o.nen_tang)) return null;
  return { ...chuanCauHinhVideo(o.cau_hinh ?? o, o.nen_tang), nen_tang: o.nen_tang };
}

// ---------------- nội dung đăng ----------------
export interface VideoDangMeta { tieuDe: string; moTa: string; hashtag: string[] }
export interface NoiDungDang { tieuDe: string; moTa: string; tong: string }

/** Giới hạn ký tự theo nền tảng (đã trừ chút lề). */
export const GIOI_HAN_NOI_DUNG: Readonly<Record<NenTangVideo, { tieuDe: number; moTa: number }>> = {
  youtube: { tieuDe: 100, moTa: 4900 },
  facebook: { tieuDe: 100, moTa: 2200 },
  tiktok: { tieuDe: 100, moTa: 2100 },
};

const catChu = (s: string, n: number): string => (Array.from(s).length <= n ? s : `${Array.from(s).slice(0, n - 1).join("").trimEnd()}…`);

/**
 * Nội dung đăng theo MẪU CỦA VIDEO (hoặc chữ AI đã viết lại thay cho mô tả). YouTube: tiêu đề riêng + mô tả (kèm hashtag cuối). Facebook / TikTok: một ô chữ =
 * tiêu đề + mô tả + hashtag. Cắt theo giới hạn nền tảng (đếm ký tự thật, không tách emoji). `moTaThay` (AI viết lại) thay cho mô tả của video.
 */
export function xayNoiDungDang(nenTang: NenTangVideo, v: VideoDangMeta, moTaThay?: string): NoiDungDang {
  const gh = GIOI_HAN_NOI_DUNG[nenTang];
  const tieuDe = catChu(chuanTieuDe(v.tieuDe), gh.tieuDe);
  const moTa0 = chuanMoTa(moTaThay !== undefined ? moTaThay : v.moTa);
  const tags = ghiHashtag(chuanHashtag(v.hashtag));
  const moTaGoc = [moTa0, tags].filter(Boolean).join("\n\n");
  if (nenTang === "youtube") {
    const moTa = catChu(moTaGoc, gh.moTa);
    return { tieuDe, moTa, tong: [tieuDe, moTa].filter(Boolean).join("\n\n") };
  }
  const tong = catChu([tieuDe, moTaGoc].filter(Boolean).join("\n\n"), gh.moTa);
  return { tieuDe, moTa: tong, tong };
}

/** Lời nhắc cho AI viết lại mô tả (giữ ý, khác chữ, không bịa). Trả { system, user } cho chonAnhAi-like. */
export function loiNhacVietLai(nenTang: NenTangVideo, v: VideoDangMeta, daDung: readonly string[], giongDieu?: string): { system: string; user: string } {
  return {
    system: `Bạn viết lại mô tả video đăng lên ${TEN_NEN_TANG_VIDEO[nenTang]} bằng tiếng Việt tự nhiên, giữ đúng ý và thông tin của bản gốc, KHÔNG bịa thêm sự kiện / số liệu / tên riêng, KHÔNG nhắc tên sản phẩm nếu bản gốc không nhắc. Mỗi lần viết một cách khác. Chỉ trả về đúng đoạn mô tả, không giải thích, không dùng Markdown, không thêm hashtag (hệ thống tự thêm).${giongDieu ? ` Giọng điệu: ${giongDieu}` : ""}`,
    user: `Tiêu đề: ${v.tieuDe}\nMô tả gốc:\n${v.moTa || "(trống)"}${daDung.length ? `\n\nCác bản KHÁC đã dùng (phải viết KHÁC hẳn, không lặp câu):\n${daDung.slice(0, 5).map((x, i) => `${i + 1}. ${catChu(x, 300)}`).join("\n")}` : ""}`,
  };
}

/** Kiểm bản AI viết lại: không rỗng, không quá giới hạn, không giống 100% bản gốc / bản đã dùng. Trả lý do hoặc null. */
export function loiVietLai(ban: string, nenTang: NenTangVideo, goc: string, daDung: readonly string[]): string | null {
  const s = chuanMoTa(ban);
  if (!s) return "AI trả về rỗng";
  if (Array.from(s).length > GIOI_HAN_NOI_DUNG[nenTang].moTa) return "AI viết quá dài";
  if (moTaGiongHet(s, goc)) return "AI chép lại y nguyên mô tả gốc";
  if (daDung.some((x) => moTaGiongHet(s, x))) return "giống hệt một bản bot khác đã đăng";
  return null;
}

/** Nội dung này có GIỐNG HỆT một bản bot khác đã đăng cho cùng video + nền tảng không (so cả khối chữ đăng). */
export function trungNoiDungDaDung(tong: string, daDung: readonly string[]): boolean {
  return daDung.some((x) => moTaGiongHet(tong, x));
}

export const LY_DO_TRUNG_MO_TA = "mô tả GIỐNG HỆT 100% bản một bot khác đã đăng cho cùng video này trên cùng nền tảng (nền tảng phạt nội dung trùng) — chọn “AI viết lại” trong bước này hoặc sửa mô tả của video ở Kho video rồi chạy lại";

/** Kiểu đăng hiện cho người. */
export const nhanKieuDang = (k: string): string => (NHAN_KIEU_DANG as Record<string, string>)[k] ?? k;
export type { KieuDangVideo };
